import React, { useContext, useEffect } from 'react'
import { KebabMenu } from './KebabMenu'
import { SecondaryButton } from './SecondaryButton'
import { rediretionHandler } from '../utils/functions'
import classNames from 'classnames'
import { NextLink } from '../commonComponents/NextLink'
import { SharedContext } from '../context/SharedContext'
import { SeekerContext } from '../context/SeekerContext'

export const JobCardFooter = ({
  jobDetails,
  isApplied,
  showKebabMenu = true,
  setLoading,
  setIsApplied,
  getImage,
  sponsoredJobs = false
}) => {
  const {
    loginDetails,
    setShowToast,
    windowSize
  } = useContext(SharedContext);
  
  const {
    setLogInOpen,
    setAppLinkModal,
    isJobProfileCreated,
    setClickedHRCTA
  } = useContext(SeekerContext);
  return (
    <>
      {showKebabMenu && (
        <div className="flex">
          <KebabMenu id={jobDetails?.id} job={jobDetails} onClick={getImage} />
        </div>
      )}
      {jobDetails?.contact_preference?.['preference'] !== 0 && !isApplied && (
        <NextLink
          href={{
            pathname: '/create_profile'
          }}
          isLoader={false}
          as={'/jobs/create_profile'}
          className={classNames('mr-[8px] w-[50%]', !sponsoredJobs && 'sm:h-[40px] sm:w-[128px]')}
          id={jobDetails?.id + 'whatsapp_chat_button'}
          onClick={async () => {
            setClickedHRCTA(true)
            if (windowSize > 640) {
              window?.scrollTo({ top: 0 })
              setAppLinkModal({ isOpen: true, jobDetails })
              return true
            } else
              return await rediretionHandler({
                link: jobDetails?.contact_preference?.whatsapp_link,
                loginDetails,
                setLogInOpen,
                setLoading,
                setIsApplied,
                jobDetails,
                setShowToast,
                window,
                isJobProfileCreated
              })
          }}
        >
          <SecondaryButton
            icon="whatsapp"
            title="Chat"
            imageClass="mr-[3px]"
            className="select-none border-[#FFBB00]"
          />
        </NextLink>
      )}

      <NextLink
        href={{
          pathname: '/create_profile'
        }}
        isLoader={false}
        as={'/jobs/create_profile'}
        className={classNames(
          jobDetails?.contact_preference?.['preference'] === 0 || isApplied
            ? 'w-[100%]'
            : 'w-[50%]',
          !sponsoredJobs && 'sm:h-[40px] sm:w-[128px]'
        )}
        id={jobDetails?.id + 'call_button'}
        onClick={() => {
          setClickedHRCTA(true)
          if (windowSize > 640) {
            window?.scrollTo({ top: 0 })
            setAppLinkModal({ isOpen: true, jobDetails })
            return true
          } else {
            if (jobDetails?.enable_lead_collection && !jobDetails?.custom_link && !isApplied) {
              if (!loginDetails?.isLogIn) {
                setLogInOpen(true)
              } else setIsShowAppiledModel(true)
              return true
            } else
              return rediretionHandler({
                link: jobDetails?.custom_link,
                loginDetails,
                setLogInOpen,
                setLoading,
                setIsApplied,
                jobDetails,
                setShowToast,
                window,
                isJobProfileCreated
              })
          }
        }}
      >
        <SecondaryButton
          title={
            windowSize > 640
              ? 'Apply'
              : isApplied && !jobDetails?.custom_link
              ? 'Applied'
              : jobDetails?.button_text || 'No Data'
          }
          icon={isApplied && !jobDetails?.custom_link && 'AppliedTick'}
          className={classNames(
            'select-none',
            isApplied && !jobDetails?.custom_link
              ? 'border-[0px] border-[white] bg-[#F7F7F7] outline-none'
              : 'border-[#FFBB00] bg-secondary'
          )}
        />
      </NextLink>
    </>
  )
}
